import React, { Component } from 'react';
import { Grid,Row,Col,Image,Button } from 'react-bootstrap';
import { Link } from 'react-router-dom'
import './Purchases.css';
import { API_ROOT } from '../../config.js';
import spinner from '../Header/Spinner-1s-150px.svg';

class Purchases extends Component {
  constructor(props) {
    super(props);
    this.state = {
      purchaseList: '',
      isLoading: true
    }
  }

  componentDidMount () {
    fetch(`${API_ROOT}/purchases`, {
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json',
        'Authorization': 'Bearer ' + localStorage.getItem('token')
      }
    })
    .then ( response => {
      if ( response.ok === true ) {
        return response.json()
      }
      if ( response.status === 404 ) {
        this.setState({isLoading:false})
        this.setState({purchaseList:this.zeroCardPurchased()})
      }
      throw new Error('Response status: ' + response.status + ', response text: ' + response.statusText)
    })
    .then( data => {
      this.props.subject('Thank you for your purchase.')

      var purchases = data.purchases.map((purchase, index) => {
        return(
          <div className="card-detail" key={purchase.order} total={purchase.total}>
            <Row>
              <Col xs={12} sm={5} md={4} lg={2}>
                <center><Image src={purchase.small_image} responsive rounded />
                {purchase.card_name} - RM{new Intl.NumberFormat('ms-MY',{
                  minimumFractionDigits: 2
                }).format(purchase.total)}
                </center>
              </Col>
              <Col xs={12} sm={7} md={8} lg={10}>
                <h3>To {purchase.recipient}</h3>
                <h4>{purchase.address}</h4>
                <h5>Purchased date: {new Intl.DateTimeFormat('en-MY', {
                  year: 'numeric',
                  month: 'short',
                  day: '2-digit',
                  hour: 'numeric',
                  minute: 'numeric',
                  timeZone: 'Asia/Kuala_Lumpur'
                }).format(new Date(purchase.create_date))}</h5>
              </Col>
            </Row>
          </div>
        )
      })
      this.setState({purchaseList:purchases, isLoading:false});
    })
    .catch((error) =>{
      //console.error(error);
    })
  }

  componentWillUnmount() {
    if (this.props.subject != null) {
      this.props.subject('')
    }
  }

  zeroCardPurchased() {
    return(
      <center>
      <h4>You {"don't"} have any cards purchased.</h4><br />
      <span className="nl-button">
        <Link to="/cards"><Button bsSize="lg">Choose a card</Button></Link>
      </span>
      </center>
    )
  }

  render() {
    document.title = 'Thank You for Your Purchase - NaleyCards'
    return (
    <Grid fluid>
      {/*<Row>
        <Col xs={12} sm={12} md={12} lg={12}>*/}
          {this.state.isLoading === true && (
            <div className="nl-loading"><img src={spinner} alt="spinner"/></div>
          )}
          {this.state.purchaseList}
        {/*</Col>
      </Row>*/}
    </Grid>
    )
  }
}

export default Purchases
